import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export class Post extends Model {
  positionId = 0; // 岗位id
  name = ""; //岗位名
}

export class PostGroup extends Model {
  positionGroupId = 0; // 分类id
  positionGroupName = "";
  positions = [new Post()];

  get name() {
    return this.positionGroupName;
  }

  get positionId() {
    return -this.positionGroupId; // 防止与子节点id重复
  }
}

export class PostList extends Model {
  positions: Post[] = [new Post()];
  positionGroups: PostGroup[] = [new PostGroup()];
  static get(companyId: string) {
    return request
      .post("/aiExam/company/positions", { companyId })
      .then(resp => {
        return new PostList().assign(resp.data.data);
      });
  }
}
